
<Detail v-if="data" :logo-on-click="logoOnClick">
    <template v-slot:header>
        <div class="row no-gutters">
            <div class="col col-8">
                <h2>
                    {{ data.title }}
                    <span
                        class="badge badge-pill badge-risk"
                        :class="['badge-risk-' + versionRiskLevel(data, version)]"
                        v-b-tooltip.hover
                        :title="hoverTitle(data, version)"
                    >
                        {{ $t("risk.levelFull." + versionRiskLevel(data, version)) }}
                    </span>
                </h2>
            </div>
            <div class="col col-4 text-right">
                <h2 style="font-weight: normal;">{{data.robust_price_vat | price}}</h2>
            </div>
        </div>
    </template>

    <template #back>
        <router-link :to="{ name: 'contracts', params: { version: version, hash: hash } }" class="btn btn-inline text-nowrap" tag="button">
            <b-icon icon="arrow-left" />&nbsp;{{ $t("contractDetail.nav.contractsList") }}
        </router-link>
    </template>

    <template #breadcrumbs>
        <div class="ellipsis">
            <router-link :to="{ name: version, params: { hash: hash } }">{{ data.analysis_name }}</router-link>
            &nbsp;/&nbsp;
            <router-link :to="{ name: 'contracts', params: { version: version, hash: hash } }">{{
                $t("overview.contracts.title")
            }}</router-link>
            &nbsp;/&nbsp;
            {{ data.title }}
        </div>
    </template>

    <template v-slot:header_small>
        <div class="row no-gutters">
            <div class="col col-12">
                <h2>
                    {{ data.title }}
                    <span class="badge badge-pill badge-risk" :class="['badge-risk-' + versionRiskLevel(data, version)]">
                        {{ $t("risk.levelFull." + versionRiskLevel(data, version)) }}
                    </span>
                </h2>
            </div>
        </div>
    </template>

    <template v-slot:menu>
        <Menu :nav="navigation" :current="currentNav" :hash="hash" :version="version" @force-nav="(n) => (forceNav = n)" />
    </template>

    <template v-slot:content>
        <section id="overview_section">
            <Summary v-bind="overviewSettings">
                <template v-slot:value(supplier)="item">
                     <router-link :to="{name: 'supplier-detail', params: {hash: hash, version:version, slug:item.value.link} }">{{ item.value.name }}</router-link>
                </template>
                <template v-slot:value(signatureDate)="item">{{ item.value | moment("D. M. YYYY") }}</template>
                <template v-slot:value(price)="item">
                    <span v-if="item.value != null">{{ item.value | price }}</span>
                    <span v-else>---</span>
                </template>
                <template v-slot:value(paymentsSum)="item">
                    <span>{{ item.value | price }}</span>
                </template>
                <template v-slot:value(sourceUrl)="item">
                    <ContractSourceLink :source="item.value" :includeSource="false" />
                </template>
            </Summary>
        </section>

        <section id="risks_section">

            <h4 class="section-title">
                {{ $t("contractDetail.nav.flags") }}
            </h4>

            <EmptySection v-show="!hasFlatFlagsData" :message="$t('contractDetail.flags.nodata')"></EmptySection>

            <div v-show="hasFlatFlagsData">
                <div class="row align-items-end">
                    <div class="col col-1 flag_header">
                        {{ $t("contractDetail.flags.header.risk") }}
                    </div>
                    <div class="col col-3 flag_header">
                        {{ $t("contractDetail.flags.header.group") }}
                    </div>
                    <div class="col flag_header">
                        {{ $t("contractDetail.flags.header.name") }}
                    </div>
                </div>

                <div v-for="(f, i) in flatFlags" :key="'flat-flag-' + i" class="row align-items-center">
                    <div class="col col-12">
                        <SupplierFlatFlag :flag="f" :version="version" />
                    </div>
                </div>

            </div>


            <div v-if="otherSupplierFlagSettings" class="row other-flags">
                <div class="col col-12">
                    <SupplierFlatFlag v-bind="otherSupplierFlagSettings" />
                </div>
            </div>

        </section>

        <section id="payments_section" v-show="isSectionEnabled('payments')">
            <InvoiceTable
                :version="version"
                :hash="hash"
                :externalData="data"
                :typeId="data.id"
                type="contract"
            />
        </section>

        <section id="nodata_section" v-show="isSectionEnabled('nodata')">
            <h4 class="section-title">
                {{ $t("contractDetail.nav.nodata") }}
            </h4>
            <EmptySection :message="$t('contractDetail.nodata.description', nodataSections)"></EmptySection>
        </section>

    </template>
</Detail>
